import { RequestKind, boolean } from '@sb/library/base';
import { ApiKeyDisplayItem, ApiKeyInputItem, ApiKeyResultItem, ApiKeySearchOptions, ApiKeyUpdateItem, DisplayItemCollection } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export const IntegrationsApiKeysRoutes = {
    Get: ApiRoute.Define({
        URL: (id: string) => `apikeys/${id}`,
        Kind: RequestKind.Get,
        ResultType: ApiKeyDisplayItem
    }),
    GetAll: ApiRoute.Define({
        URL: `apikeys`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<ApiKeyDisplayItem>
    }),
    Search: ApiRoute.Define({
        URL: `search/apikeys`,
        Kind: RequestKind.Post,
        BodyType: ApiKeySearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<ApiKeyDisplayItem>,
    }),
    Add: ApiRoute.Define({
        URL: 'apikeys',
        Kind: RequestKind.Post,
        BodyType: ApiKeyInputItem,
        ResultType: ApiKeyResultItem
    }),
    Delete: ApiRoute.Define({
        URL: (id: string) => `apikeys/${id}`,
        Kind: RequestKind.Delete,
        ResultType: boolean,
    }),
    Update: ApiRoute.Define({
        URL: (id: string) => `apikeys/${id}`,
        Kind: RequestKind.Put,
        BodyType: ApiKeyUpdateItem,
        ResultType: boolean,
    }),
}
